import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import {
  ProgressGauge,
  ProgressGaugeCollapsed,
} from '@saucelabs/sl-component-gauges';
import { UNLIMITED_MINUTES } from '@saucelabs/sl-util-config';
import {
  IconAutomated, IconLive,
} from '@saucelabs/sl-component-icons';

import * as constants from './constants';

const TimeChart = ({
  collapsed,
  collapsedProgressGaugeLabel,
  labelPrefix,
  minutesLimit,
  minutesRemaining,
  noLabelSuffix,
  onClick,
}) => {
  if (minutesLimit === UNLIMITED_MINUTES) {
    return null;
  }

  const fillPercentage = Math.abs(minutesLimit) < Number.MIN_VALUE ?
    0 :
    Math.round(((minutesRemaining > 0 ? minutesRemaining : 0) / minutesLimit) * 100);
  const exceeded = fillPercentage <= 0;
  const almostExceeded = !exceeded && fillPercentage <= 10;
  const labelNoSuffix = `${labelPrefix} ${noLabelSuffix}`;

  if (collapsed) {
    return (
      <ProgressGaugeCollapsed
        almostExceeded={almostExceeded}
        exceeded={exceeded}
        Icon={labelPrefix === constants.PREFIX_AUTOMATED ? IconAutomated : IconLive}
        label={collapsedProgressGaugeLabel}
        onClick={onClick}
      >
        {minutesRemaining}
        {' '}
        m
      </ProgressGaugeCollapsed>
    );
  }

  const remainingLabelClass = classNames('transition-all duration-1000', {
    'text-blue-400': !almostExceeded && !exceeded,
    'text-orange-600': almostExceeded,
    'text-red-900': exceeded,
  });

  // !collapsed
  return (
    <ProgressGauge
      almostExceeded={almostExceeded}
      current={minutesRemaining}
      exceeded={exceeded}
      label={labelNoSuffix}
      limit={minutesLimit}
      onClick={onClick}
    >
      <div className="text-center flex justify-center align-baseline whitespace-pre">
        <span className={remainingLabelClass}>
          {minutesRemaining}
          {' '}
          m
        </span>
      </div>
    </ProgressGauge>
  );
};

TimeChart.propTypes = {
  collapsed: PropTypes.bool.isRequired,
  collapsedProgressGaugeLabel: PropTypes.string,
  labelPrefix: PropTypes.PropTypes.oneOf([
    constants.PREFIX_AUTOMATED,
    constants.PREFIX_LIVE,
  ]).isRequired,
  minutesLimit: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]).isRequired,
  minutesRemaining: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]).isRequired,
  noLabelSuffix: PropTypes.string,
  onClick: PropTypes.func,
};

TimeChart.defaultProps = {
  collapsedProgressGaugeLabel: '',
  noLabelSuffix: 'Hours',
  onClick: undefined,
};

export default TimeChart;
